<template>
    <div id="pie-echart2"></div>
  </template>
  
  <script>
  import echarts from "echarts";
  export default {
    data() {
      return {
        chart4: null
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
      window.addEventListener("resize", this.resize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);   
      if (!this.chart4) {
        return
      }
      this.chart4.dispose()
      this.chart4 = null
    },
    methods: {
      initChart() {
        this.chart4 = echarts.init(document.getElementById("pie-echart2"));
        var data = [
          {value:5, name:'已缴纳'},
          {value:2.5, name:'未缴纳'},
          {value:2.5, name:'进行中'}
        ]
        var sum = 0
        data.forEach((v, i) => {
          sum = sum + v.value;
        })
        let options = {
          tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color:['#185EFC','#FE783B','#F8DA3A'],
          legend: {
              orient: 'vertical',
              icon:'rect',
              x: '39%',
              y:'28%',
              itemWidth: 10,
              itemHeight: 10,
              data: ['已缴纳','未缴纳','进行中'],
              textStyle: {
                rich: {
                    a: {
                        color: '#000',
                        width: 52
                    },
                    b0: {
                        color: '#185EFC',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        width: 70,
                        padding:[4,0,4,0]
                    },
                    b1: {
                        color: '#FE783B',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        width: 70,
                        padding:[4,0,4,0]
                    },
                    b2: {
                        color: '#F8DA3A',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        width: 70,
                        padding:[4,0,4,0]
                    }
                  }
                },
              formatter: function(name) {
                  let title = ''
                  var total = 0;
                  var target;
                  var pres;
                  var index;
                  for (var i = 0, l = data.length; i < l; i++) {
                      if (data[i].name == name) {
                          target = data[i].value;
                          pres = (data[i].value / sum * 100).toFixed(1) + "%";
                          title = data[i].label
                          index = i < 6 ? i : 5
                      }
                  }
                  return `{a| ${name}}{b${index}| ${target}万元}`+''+`{b${index}| ${pres}}`
              }
          },
          series : [
              {
                  name: '案件来源',
                  type: 'pie',
                  radius : ['32%','45%'],
                  center: ['20%', '50%'],
                  data:data,
                  itemStyle: {
                      emphasis: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  },
                  itemStyle: {
                      normal: {
                          label:{ 
                                show: false, 
    //	                            position:'inside',
                                formatter: '{b} : {c} ({d}%)' 
                            }
                      },
                        labelLine :{show:true}
                  }
              }
          ]
        }
        this.chart4.setOption(options
          )
      },
        resize(){
            if(this.chart4){
                this.chart4.resize();
            }
        }
    }
  }
  </script>

<style scoped>
#pie-echart2{ width: 100%; height: 100%;}
</style>
  